export const ResLoading = () => (
  <div className="flex items-center justify-center h-64">
    <svg
      className="animate-spin h-10 w-10 text-green-500"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24">
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"></circle>
    </svg>
  </div>
);
